import { Globals } from '../../modules/Globals';
import axios from 'axios';
import { ICaja } from '../../interfaces/ICaja';
import { ICajaMovement } from '@/interfaces/ICajaMovement';

const apiUrl =
  Globals.apiPath +
  '/restaurants/:restaurantId/branches/:branchId/cajas/:cajaId/movements';

function getApiUrl(restaurantId: number, branchId: number, cajaId: number) {
  return apiUrl
    .replace(':restaurantId', restaurantId.toString())
    .replace(':branchId', branchId.toString())
    .replace(':cajaId', cajaId.toString());
}

export default class CajaMovementsService {
  constructor() {}

  static async getAll(
    restaurantId: number,
    branchId: number,
    cajaId: number,
    statusId?: number
  ): Promise<ICajaMovement[]> {
    let url = getApiUrl(restaurantId, branchId, cajaId);

    if (typeof statusId === 'number') {
      url += `?statusId=${statusId}`;
    }

    let res = await axios.get<ICajaMovement[]>(url);
    return res.data;
  }

  static async create(data: {
    restaurantId: number;
    branchId: number;
    cajaId: number;
    type: ICajaMovement['type'];
    paymentMethod?: ICajaMovement['paymentMethod'];
    description?: string;
    amount: number;
  }): Promise<ICajaMovement> {
    let res = await axios.post<ICajaMovement>(
      getApiUrl(data.restaurantId, data.branchId, data.cajaId),
      {
        type: data.type,
        paymentMethod: data.paymentMethod,
        description: data.description,
        amount: data.amount,
      }
    );
    return res.data;
  }

  static async changePaymentMethod({
    restaurantId,
    branchId,
    cajaId,
    movementId,
    paymentMethod,
  }: {
    restaurantId: number;
    branchId: number;
    cajaId: number;
    movementId: number;
    paymentMethod: ICajaMovement['paymentMethod'];
  }): Promise<ICajaMovement> {
    let res = await axios.put<ICajaMovement>(
      `${getApiUrl(
        restaurantId,
        branchId,
        cajaId
      )}/${movementId}/paymentMethod`,
      {
        paymentMethod,
      }
    );
    return res.data;
  }

  static async reimburse({
    restaurantId,
    branchId,
    cajaId,
    movementId,
  }: {
    restaurantId: number;
    branchId: number;
    cajaId: number;
    movementId: number;
  }): Promise<ICajaMovement> {
    let res = await axios.put<ICajaMovement>(
      `${getApiUrl(restaurantId, branchId, cajaId)}/${movementId}/reimburse`
    );
    return res.data;
  }
}
